import {FC} from "react";
import {Routes, Route} from "react-router-dom";
import {AdminScheduledReportsPage} from "./AdminScheduledReportsPage";

export const ScheduledReportsRouter: FC = () => {
	return (
		<Routes>
			<Route path="/" element={<AdminScheduledReportsPage />} />
		</Routes>
	);
};

